<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="col-lg-12 col-md-12 col-12">
    <div class="card">
      <div class="card-body">
        
        <div class="col-lg-12 col-md-12 col-12">
          <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills" (navChange)="onTab($event)" orientation="horizontal">

            <!-- TAB1 new request -->
            <ng-container ngbNavItem="payments">
              <button ngbNavLink>Payments</button>
              <ng-template ngbNavContent>

                  <div class="row align-items-center">
                    <div class="col-lg-3 col-md-12 col-12">
                      <div class="card o-hidden">
                        <div class="b-r-4 card-body inniver-bg-revenue-color">
                          <div class="media static-top-widget text-white">
                            <div class="align-self-center text-center">
                              <app-feather-icons [icon]="'activity'"></app-feather-icons>
                            </div>
                            <div class="media-body"><span class="m-0">Current revenue</span>
                              <h4 class="mt-0 mb-0"><span>$ {{chartOptionCurrent}}</span></h4>
                              <i class="icon-bg" data-feather="activity"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-md-12 col-12">
                      <div class="card o-hidden">
                        <div class="b-r-4 card-body inniver-bg-pendingpayout-color">
                          <div class="media static-top-widget text-white">
                            <div class="align-self-center text-center">
                              <app-feather-icons [icon]="'shopping-cart'"></app-feather-icons>
                            </div>
                            <div class="media-body"><span class="m-0">Pending payout</span>
                              <h4 class="mt-0 mb-0"><span>$ {{chartOptionPending}}</span></h4>
                              <i class="icon-bg" data-feather="shopping-cart"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-md-12 col-12">
                      <div class="card o-hidden">
                        <div class="b-r-4 card-body inniver-bg-fee-color">
                          <div class="media static-top-widget text-white">
                            <div class="align-self-center text-center">
                              <app-feather-icons [icon]="'credit-card'"></app-feather-icons>
                            </div>
                            <div class="media-body"><span class="m-0">Fee in total</span>
                              <h4 class="mt-0 mb-0"><span>$ {{chartOptionFee}}</span></h4>
                              <i class="icon-bg" data-feather="credit-card"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-md-12 col-12">
                      <div class="card o-hidden">
                        <div class="b-r-4 card-body inniver-bg-profit-color">
                          <div class="media static-top-widget  text-white">
                            <div class="align-self-center text-center">
                              <app-feather-icons [icon]="'home'"></app-feather-icons>
                            </div>
                            <div class="media-body"><span class="m-0">Paid out in total</span>
                              <h4 class="mt-0 mb-0"><span>$ {{chartOptionTotal}}</span></h4>
                              <i class="icon-bg" data-feather="home"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-12 col-12">
                      <div class="card">
                        <div class="card-body">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Your Payment term</label>
                              <div class="col-sm-9">
                                <input type="text" class="form-control" value="{{payout.payTerm}}" disabled>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Min withdrawal amount</label>
                              <div class="col-sm-3">
                                  <input type="text" class="form-control" value="{{payout.minAmount | currency}}" disabled>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Your current revenue</label>
                              <div class="col-sm-3" *ngIf="payout.currentRevenue-payout.minAmount<0">
                                  <input type="text" class="form-control" value="{{payout.currentRevenue | currency}}" disabled
                                  [ngStyle]="{ 'color': '#FF0000'}">
                              </div>
                              <div class="col-sm-3" *ngIf="payout.currentRevenue-payout.minAmount>=0">
                                <input type="text" class="form-control" value="{{payout.currentRevenue | currency}}" disabled
                                [ngStyle]="{ 'color': '#24811D'}">
                              </div>
                              <label class="col-sm-6 col-form-label" *ngIf="payout.currentRevenue-payout.minAmount<0">Still missing for payment <b>{{payout.minAmount-payout.currentRevenue | currency}}</b></label>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Date of the next possible your payment</label>
                              <div class="col-sm-4">
                                <input type="text" class="form-control" value="{{payout.payoutDate | date:'d/MM/yyyy'}}" disabled>
                              </div>
                              <label class="col-sm-3 col-form-label">in <b>{{getnextpaydayDate(this.payout.payoutDate)}}</b> days</label>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">My preferred payout method</label>
                              <div class="col-sm-4">
                                <select class='form-select' [(ngModel)]='payout.preffered' (change)="setPreffered($event)" >
                                  <option value='Wire'>Wire</option>
                                  <option value='Payoneer'>Payoneer</option>
                                  <option value='Paypal'>PayPal</option>
                              </select>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-12 col-12">
                      <div class="card">
                          <div class="card-body custom-datatable">
                            <ngx-datatable
                            class='bootstrap'
                            [rows]="payoutsData"
                            [columnMode]="ColumnMode.force"
                            [headerHeight]="50"
                            [footerHeight]="50"
                            [rowHeight]="'auto'"
                            [externalPaging]="true"
                            [count]="page.totalElements"
                            [offset]="page.pageNumber"
                            [limit]="page.size"
                            (page)="setPage($event)"
                            [sorts]="[{prop: 'date', dir: 'desc'}]"
                            >

                            <ngx-datatable-column name="date">
                              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                                <span class="myHeader txt-primary" (click)="sort()">Payouts date</span>
                              </ng-template>
                              <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.date | date:'d/MM/yyyy'}}
                              </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="payoutStatus.name" prop="payoutStatus.name" [sortable]="false">
                              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                                <span class="myHeader txt-primary" (click)="sort()">Status</span>
                              </ng-template>
                              <ng-template let-row="row" ngx-datatable-cell-template>
                                <div *ngIf="row.payoutStatus.name=='PendingToPayout'">
                                  <span class="badge badge-warning">{{ row.payoutStatus.name }}</span>
                                </div>
                                <div *ngIf="row.payoutStatus.name=='Paid'">
                                  {{ row.payoutStatus.name }}
                                </div>
                                <div *ngIf="row.payoutStatus.name=='Reverted'">
                                  <span class="badge badge-danger">{{ row.payoutStatus.name }}</span>
                                </div>
                              </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="payoutMethod.name" prop="payoutMethod.name">
                              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                                <span class="myHeader txt-primary" (click)="sort()">Method</span>
                              </ng-template>
                              <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.payoutMethod.name }}
                              </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="amount">
                              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                                <span class="myHeader txt-primary" (click)="sort()">Amount</span>
                              </ng-template>
                              <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.amount | currency}}
                              </ng-template>
                            </ngx-datatable-column>
                            </ngx-datatable>
                        </div>
                      </div>
                    </div>
                  </div>
              </ng-template>
            </ng-container>

              <!-- TAB2 method -->
              <ng-container ngbNavItem="method">
                <button ngbNavLink>Payout method</button>
                <ng-template ngbNavContent>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="card">                                  
                        <div class="card-header">                                    
                          <h5><img src="../../../../assets/images/payout/wire.png" alt="wire bank" height="40">&nbsp; Wire</h5>
                        </div>
                        <div class="card-body">
                          <div class="form-group">
                            <label class="form-label">Account holder</label>
                            <input class="form-control" type="text" placeholder="account holder" [(ngModel)]="method.wireAccountHolder">
                          </div> 

                          <div class="row">
                            <div class="col-md-7">
                              <div class="form-group">
                                <label class="form-label">Bank name</label>
                                <input class="form-control" type="text" placeholder="bank name" [(ngModel)]="method.wireBankName">
                              </div>
                            </div>

                            <div class="col-md-5">
                              <div class="form-group">
                                <i class="flag-icon flag-icon-{{flag | lowercase}}"></i>&nbsp;
                                <label>Bank country</label>
                                <select class="form-select" id="country"  [(ngModel)]="method.wireBankCountryId" (change)="setFlag($event)">
                                  <option [ngValue]="null" selected disabled>country..</option>
                                  <option *ngFor="let country of countryData" [value]="country.id">{{country.name}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Account number / IBAN</label>
                            <input class="form-control" type="text" placeholder="account number / IBAN" [(ngModel)]="method.wireIban">
                          </div>
                          <div class="form-group">
                            <label class="form-label">SWIFT / BIC</label>
                            <input class="form-control" type="text" placeholder="SWIFT / BIC" [(ngModel)]="method.wireSwift">
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <div class="form-group">
                                <label class="form-label">Payment $ fee for each request</label>
                                <input class="form-control col-lg-4" type="number" step="0.01" value="{{payout.wireFee}}" disabled>
                              </div>
                            </div>
                          </div>
                          <div class="form-footer">
                            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="save payments method" (click)="onSave()">
                              Save</button>
                          </div>
                        </div>

                      </div>
                    </div>                              
                    <div class="col-lg-6">
                      <div class="card">                                  
                        <div class="card-header">                                    
                          <h5><img src="../../../../assets/images/payout/payoneer.png" alt="wire bank" height="40"></h5>
                        </div>
                        <div class="card-body">
                          <div class="form-group">
                            <label class="form-label">Payoneer email address</label>
                            <input class="form-control" type="text" placeholder="email" [(ngModel)]="method.payoneerEmail">
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <div class="form-group">
                                <label class="form-label">Payment $ fee for each request</label>
                                <input class="form-control col-lg-4" type="number" value="{{payout.payoneerFee}}" disabled>
                              </div>
                            </div>
                          </div>
                          <div class="form-footer">
                            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="save payments method" (click)="onSave()">
                              Save</button>
                          </div>
                        </div>
                      </div>

                      <div class="card">                                  
                        <div class="card-header">                                    
                          <h5><img src="../../../../assets/images/payout/paypal.png" alt="wire bank" height="40"></h5>
                        </div>
                        <div class="card-body">
                          <div class="form-group">
                            <label class="form-label">PayPal email address</label>
                            <input class="form-control" type="text" placeholder="email" [(ngModel)]="method.payPalEmail">
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <div class="form-group">
                                <label class="form-label">Payment $ fee for each request</label>
                                <input class="form-control col-lg-4" type="number" step="0.01" value="{{payout.payPalFee}}" disabled>
                              </div>
                            </div>
                          </div>
                          <div class="form-footer">
                            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="save payments method" (click)="onSave()">
                              Save</button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                            
                </ng-template>
              </ng-container>

          </div>
          <div [ngbNavOutlet]="nav" class="ms-4"></div>

      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
